import { Typography, Tooltip, TypographyProps } from "@mui/material";

interface Props extends TypographyProps {
  text: string;
  maxLength?: number;
}

const TruncatedText = ({ text, maxLength, ...typographyProps }: Props) => {
  // 1. Initial check: If no limit or text is short enough, return as-is
  if (!maxLength || text.length <= maxLength) {
    return <Typography {...typographyProps}>{text}</Typography>;
  }

  // 2. Smart Truncation: Find the last space within the limit
  let truncated = text.substring(0, maxLength);
  const lastSpace = truncated.lastIndexOf(" ");

  // If there's a space, cut there so we don't break a word
  if (lastSpace > 0) {
    truncated = truncated.substring(0, lastSpace);
  }

  const displayText = `${truncated.trim()}...`;

  return (
    <Tooltip title={<Typography>{text}</Typography>} arrow placement="top">
      <Typography {...typographyProps}>{displayText}</Typography>
    </Tooltip>
  );
};

export default TruncatedText;
